import * as API from '../data/report_template_api';
import {signOutAction} from "./auth_actions";

export const GET_TEMPLATE_LIST = "get_available_report_templates";
export const ADD_OR_UPDATE_TEMPLATE = "create_or_update_report_templates";

export function getTemplateList() {
    return async (dispatch) => {
        const response = await API.getTemplateList();
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({
                type: GET_TEMPLATE_LIST,
                payload: response
            });
        }
    };
}

export function addOrUpdateTemplate(action,formData,successCallBack) {
    return async (dispatch) => {
      const response = await API.addOrUpdateTemplate(action,formData);
      if(response.status === 401){
          dispatch(signOutAction());
      }
      else {
          successCallBack(response);
      }
    };
}


// WEBPACK FOOTER //
// ./src/actions/report_template_action.js